import { SystemComponentBuilder } from '@salsita-ai/platform-project-sdk/domain';
export const stackComponent = SystemComponentBuilder.component('stack').withState({
    type: 'object',
    tsType: 'StackComponenState',
    import: [
        {
            module: '@salsita-ai/platform-project-sdk/domain',
            member: 'StackComponenState'
        }
    ],
    properties: {
        stackKey: {
            type: 'string'
        },
        parentEntityId: {
            type: 'string'
        },
        min: {
            type: 'number'
        },
        max: {
            type: 'number'
        }
    },
    required: [
        'stackKey',
        'parentEntityId',
        'min',
        'max'
    ],
    additionalProperties: false
}).build();
export const stackItemComponent = SystemComponentBuilder.component('stackItem').withState({
    type: 'object',
    tsType: 'StackItemComponenState',
    import: [
        {
            module: '@salsita-ai/platform-project-sdk/domain',
            member: 'StackItemComponenState'
        }
    ],
    properties: {
        width: {
            type: 'number'
        },
        x: {
            type: 'number'
        },
        stackKey: {
            type: 'string'
        }
    },
    required: [
        'width',
        'x',
        'stackKey'
    ],
    additionalProperties: false
}).withWritableKeys([
    'stackKey',
    'x'
]).build();

//# sourceMappingURL=stack-component.js.map